<script>
import {
    selectedTags,
    selectedTagIds,
    selectedCates,
    selectedCateIds
} from './store';
import {
    get
} from 'svelte/store';
import {
    onMount,
    onDestroy
} from 'svelte';

export let content;
export let type;
export let adminPickedCategory,adminPickedTags;

const allowedTypes = ['tags', 'categories'];
if (!allowedTypes.includes(type)) {
    throw new Error(`Invalid type: "${type}". Only "tags" and "categories" are allowed.`);
}

let searchQuery = '';
let dropdownOpen = false;
let dropdownRef;

let filteredItems = content;

$: filteredItems = content.filter(tag => tag.value.toLowerCase().includes(searchQuery.toLowerCase()));

let selectedCatItems, selectedTagItems;


function toggleTag(tag) {
    

    if (type === 'tags') {
        selectedCatItems = selectedTags;
        selectedTagItems = selectedTagIds;
    } else if (type === 'categories') {
        selectedCatItems = selectedCates;
        selectedTagItems = selectedCateIds;
    }

    const tagIds = get(selectedTagItems);

    if (tagIds.includes(tag.id)) {
        selectedCatItems.update(items => items.filter(t => t.id !== tag.id));
        selectedTagItems.update(ids => ids.filter(id => id !== tag.id));
    } else {
        selectedCatItems.update(items => [...items, tag]);
        selectedTagItems.update(ids => [...ids, tag.id]);
    }
    
}


function openDropdown() {
    dropdownOpen = true;
}

function closeDropdown() {
    dropdownOpen = false;
}

function stopPropagation(event) {
    event.stopPropagation();
}

function handleOutsideClick(event) {
    if (dropdownOpen && dropdownRef && !dropdownRef.contains(event.target)) {
        closeDropdown();
    }
}

onMount(() => {
   
    if (adminPickedCategory !== undefined && adminPickedCategory.length !== 0) {
        selectedCates.update(items => [...items, ...adminPickedCategory]);
        selectedCateIds.update(ids => [...ids, ...adminPickedCategory.map(item => item.id)]);
    }

    // Handling adminPickedTags
    if (adminPickedTags !== undefined && adminPickedTags.length !== 0) {
        selectedTags.update(items => [...items, ...adminPickedTags]);
        selectedTagIds.update(ids => [...ids, ...adminPickedTags.map(item => item.id)]);
    }
    window.addEventListener('click', handleOutsideClick);
});

onDestroy(() => {
    window.removeEventListener('click', handleOutsideClick);
});
</script>

<div class="dropdown" bind:this={dropdownRef}>
    <input
        type="text"
        class="w-full h-[44px] bg-pm-white text-pm-grey border border-snd-lightgrey rounded-[10px] py-2 px-4 outline-0"
        placeholder={`Search ${type}...`}
        bind:value={searchQuery}
        on:focus={openDropdown}
        />

    {#if dropdownOpen}
    <div class="dropdown-list" on:mousedown|preventDefault on:click={stopPropagation}>
        {#each filteredItems as tag}
        <div class="dropdown-item">
            <div class="flex items-center">
                <input
                    type="checkbox"
                    id={`checkbox-${tag.id}`}
                    class="opacity-0 absolute h-8 w-8"
                    checked={(type === 'tags' && $selectedTagIds.includes(tag.id)) || (type === 'categories' && $selectedCateIds.includes(tag.id))}
                    on:change={() => toggleTag(tag)}
                    
                />
                <div class="border shadow-insett bg-pm-white rounded-md border-pm-pink w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2">
                    <span class="tick {((type === 'tags' && $selectedTagIds.includes(tag.id)) || (type === 'categories' && $selectedCateIds.includes(tag.id))) ? '' : 'hidden'}">
                        <i class="si-solid si-check text-sm text-pm-white"></i>
                    </span>
                </div>
                <label for={`checkbox-${tag.id}`} class="select-none text-pm-black text-base">{tag.value}</label>
            </div>
        </div>
        {/each}
    </div>
    {/if}
</div>

<style>
.dropdown {
    position: relative;
}

.dropdown input[type="text"] {
    width: 100%;
    box-sizing: border-box;
}

.dropdown-list {
    position: absolute;
    width: 100%;
    border: 1px solid #ccc;
    background: white;
    max-height: 200px;
    border-radius: 0 0 10px 10px;
    overflow-y: auto;
    z-index: 1;
}

.dropdown-item {
    padding: 8px 16px;
    cursor: pointer;
}

.dropdown-item .flex {
    display: flex;
    align-items: center;
}

.tick {
    display: inline-block;
}

.hidden {
    display: none;
}
</style>
